import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { PREHEADER } from 'utils/sectionTypes';
import styles from 'components/sections/Preheader/Preheader.scss';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';
import style from './PreheaderText.scss';

const PreheaderText = ({ children }) => {
  const [header] = React.Children.toArray(children);

  return (
    <div className={`${styles.root} color-tertiary-background`}>
      <Container>
        <Row>
          <Col xs={12} className={style.text}>
            {header}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

PreheaderText.propTypes = {
  children: PropTypes.node.isRequired,
};

const component = section(
  { name: 'Preheader: Text', region: PREHEADER, category: 'Preheader' },
  {
    subsections: [
      { accepts: ['HeaderText'] },
    ],
    defaults: [
      ['HeaderText', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: '1-800-555-5555',
              type: 'header-two',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
    ],
  },
)(PreheaderText);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
